import APIClient from '@/shared/http/clients/api'

const resourceName = 'RECredenciada'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}?limit=${limit}&index=${index}`, data, config)
const GetAllAccredite = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Add = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const PostCredenciada = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const PutCredenciada = (data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const PutInativeAccredited = (id, data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/Inativar/${id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/${id}`, config)
const DeleteAccredited = (id, data, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/${id}`, data, config)
const GetRequestsByFiltro = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/filtro?limit=${limit}&index=${index}`, data, config)
const GetName = (name, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetByName/${name}`, data, config)

const AccrediteddateRepository = {
  GetAll,
  GetAllAccredite,
  GetAllPaging,
  Create,
  Add,
  PostCredenciada,
  Update,
  PutCredenciada,
  PutInativeAccredited,
  Delete,
  DeleteAccredited,
  GetRequestsByFiltro,
  GetName
}

export default AccrediteddateRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/accrediteddate.js